import { createBrowserRouter, createRoutesFromElements, Route } from 'react-router-dom';
import EmptyState from '@rio-cloud/rio-uikit/EmptyState';

import App from '@/features/app/App';
import { ErrorBoundary } from '@/features/app/ErrorBoundary';
import { BrakeLiningPage } from '@/features/brakes/BrakeLiningPage';
import CustomerDetailsDialog from '@/features/common/components/dialogs/CustomerDetailsDialog';
import {
    ASSIGNMENTS_DIALOG_PATH,
    TABLE_SETTINGS_DIALOG_PATH,
    WORKSHOPS_DIALOG_PATH,
} from '@/features/common/components/dialogs/dialogConstants';
import UserSettingsDialog from '@/features/common/components/dialogs/UserSettingsDialog';
import WorkshopDetailsDialog from '@/features/common/components/dialogs/WorkshopDetailsDialog';

export const router = createBrowserRouter(
    createRoutesFromElements(
        <Route path="/" element={<App />}>
            <Route index element={<EmptyState />} />
            <Route path="brakes" errorElement={<ErrorBoundary />} element={<BrakeLiningPage />} />
            <Route
                path={`${ASSIGNMENTS_DIALOG_PATH}/:assetId`}
                errorElement={<ErrorBoundary />}
                element={<CustomerDetailsDialog />}
            />
            <Route
                path={`${WORKSHOPS_DIALOG_PATH}/:id`}
                errorElement={<ErrorBoundary />}
                element={<WorkshopDetailsDialog />}
            />
            <Route
                path={`${TABLE_SETTINGS_DIALOG_PATH}/:diagnosticsTableView`}
                errorElement={<ErrorBoundary />}
                element={<UserSettingsDialog />}
            />
        </Route>,
    ),
);
